import _ from 'lodash'
import ProductPicker from './ProductPicker'
import { AppDispatch, RootState } from '@/stores'
import { useDispatch, useSelector } from 'react-redux'
import { replaceCastInChannelAction, replaceTBoltAction } from '@/stores/active-design'
import { ProductVariantResource, useLazyGetDesignsByDesignValidateQuery } from '@/api/serverApi'
import { useCallback } from 'react'
import ComponentType from '@/enums/ComponentType'

type ProductPickerPropTypes = {
  isOpen: boolean
  onClose: () => void
  productType?: string
  parentId?: string
  componentId?: string
}

const ReplaceProductPicker = ({ isOpen, onClose, productType, parentId, componentId }: ProductPickerPropTypes) => {
  const dispatch = useDispatch<AppDispatch>()
  const { design } = useSelector((state: RootState) => state.activeDesign)

  const [validate] = useLazyGetDesignsByDesignValidateQuery()

  const onValidate = useCallback(async (product: ProductVariantResource) => {
    const response = await validate({
      design: design!.id,
      replacementProductVariantId: product.id,
      componentToReplaceId: componentId,
    }, false)

    return response.data
  }, [validate, design, componentId])

  return (
    <>
      {
        productType && parentId && componentId
          && (
            <ProductPicker
              isOpen={isOpen}
              onClose={onClose}
              productType={productType}
              parentId={parentId}
              onConfirm={(productVariant, tBoltOption) => {
                switch (productVariant.product_type) {
                  case ComponentType.CastInChannel:
                    dispatch(replaceCastInChannelAction({
                      componentId: componentId,
                      body: {
                        new_product_variant_id: productVariant.id,
                        ...tBoltOption && {
                          t_bolt: {
                            variant_id: tBoltOption!.productVariant!.id,
                            diameter: tBoltOption!.diameter.name,
                          },
                        },
                      },
                    }))
                    break
                  case ComponentType.TBolt:
                    dispatch(replaceTBoltAction({
                      componentId: componentId,
                      body: {
                        new_product_variant_id: productVariant.id,
                      },
                    }))
                    break
                }

                onClose()
              }}
              onValidate={onValidate}
            />
          )
      }
    </>
  )
}

export default ReplaceProductPicker
